import { Box } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipISSTaxJuridicionCity = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.3 }}>
            <TooltipPopover>
                A cidade de incidência é o município que tem direito ao recolhimento do ISS (Imposto Sobre Serviços) da nota fiscal. 
                Escolha "Endereço do cliente" somente quando a legislação exigir que o imposto do serviço prestado seja recolhido no município do seu cliente (consultar LC 116/03).
                Em caso de dúvida, consulte o seu contador.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipISSTaxJuridicionCity;